<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0">
        <tt-card class="col-xs-12 col-md-3 p-5">
            <form class="form-horizontal sp-0" name="formProductWaste" novalidate (ngSubmit)="searchItems()" method="get" role="form">
                <tt-input ttRememberId="w_productwaste.searchtext" ttLabel="searchtext" [(ttModel)]="setting.searchtext" (ttModelChange)="onChanged($event, 'searchtext')" ttShowClearButton [ttButtons]="searchTextButtons"></tt-input>
            </form>
        </tt-card>

        <tt-card class="col-xs-12 col-md-3 p-5">
            <tt-select ttRememberId="w_productwaste.prodtype_no" ttLabel="prodtype" [(ttModel)]="setting.prodtype_no" (ttModelChange)="onChanged($event, 'prodtype_no')" [ttData]="selectListProductType" ttDataId="prodtype_no" ttDataName="prodtype_name"></tt-select>
        </tt-card>
    </div>

    <tt-grid *ngIf="!!grid" class="p-5 flex-1" [(ttOptions)]="grid"></tt-grid>
</tt-page>
